import React, { useState } from "react";
import AccessDenied from "../../Pages/Access Denied/AccessDenied";
import { getContextFromLocalStorage } from "../Context/Context";

const Protected = ({ permittedPages, pageContext, children }) => {
  const context = getContextFromLocalStorage();
  var results = false;

  if (context != undefined) {
    context.Permissions.map((permission) => {
      if (Object.keys(context.loggedInAs).length === 0) {
        context.loggedInAs = context.Roles[0];
      }
      if (permission.SystemName === permittedPages && permission.Role === context.loggedInAs.label) {
        results = true;
      }
    });

    //results = context.Permissions.includes(permittedPages);
  }

  if (!results) {
    // return <Navigate to={`/AccessDenied`} replace />;
    return <AccessDenied />;
  }
  return children;
};
export default Protected;
